import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sas-button',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './sas-button.component.html',
  styleUrl: './sas-button.component.scss'
})
export class SasButtonComponent {
  @Input() customClass!: string;
  @Input() disabled!: boolean;
  @Input() sasId!: string;
  @Input() text!: string;
  @Input() type!: string;
  @Input() class!: string;
  @Output() sasOnClick = new EventEmitter<any>();

  classes: string = '';
  ariaDisabled: boolean = false;

  ngOnInit() {
    let defaultText: string = '';

    switch (this.type) {
      case 'search':
        this.classes = 'btn-primary sas-search-btn';
        defaultText = 'BUTTON.SEARCH.TEXT';
        break;
      case 'reset':
        this.classes = 'btn-primary sas-reset-btn';
        defaultText = 'BUTTON.RESET.TEXT';
        break;
      case 'accept':
        this.classes = 'btn-primary sas-accept-btn';
        defaultText = 'BUTTON.ACCEPT.TEXT';
        break;
      case 'submit':
          this.classes = 'btn-primary sas-submit-btn';
          defaultText = 'BUTTON.ACCEPT.TEXT';
          break;
      case 'delete':
        this.classes = 'btn-primary sas-delete-btn';
        defaultText = 'BUTTON.DELETE.TEXT';
        break;
      case 'save':
        this.classes = 'btn-primary sas-save-btn';
        defaultText = 'BUTTON.SAVE.TEXT';
        break;
      case 'cancel':
        this.classes = 'btn-primary sas-cancel-btn';
        defaultText = 'BUTTON.CANCEL.TEXT';
        break;
      default:
        this.type = 'button';
        this.classes = 'btn-default sas-default-btn';
        defaultText = '';
    }

    this.text = this.text !== undefined && this.text.length ? this.text : defaultText;

    this.class = this.class !== undefined && this.class.length ? this.class : 'button';

    if (this.customClass !== undefined && this.customClass.length) {
      this.classes += ` ${this.customClass}`;
    }

    this.ariaDisabled = this.disabled ?? this.ariaDisabled;
  }

  onClick(event: any) {
    if (this.sasOnClick !== undefined) {
      this.sasOnClick.emit({ event });
      event.stopPropagation();
    }
  }
}
